/* global BigInt */
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { TruckIcon } from "@heroicons/react/20/solid";
import { useForm } from "react-hook-form";
import { Button, TextInput, Select, Label, Alert } from "flowbite-react";
import { CheckCircle, XCircle } from "lucide-react";
export function RecupererTransfert({
  open,
  onSuccessClose,
  onClose,
  adminV,
  entity,
  torole,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const firstIccid = watch("first_iccid");
  const iccidValidation = {
    required: "Ce champ est obligatoire",
    pattern: {
      value: /^\d{20}$/,
      message: "L'ICCID doit contenir exactement 20 chiffres",
    },
    onChange: (e) => {
      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 20);
    },
  };
  const lastIccidValidation = {
    ...iccidValidation,
    validate: (value) => {
      if (!firstIccid || !value) return true;
      return (
        BigInt(value) > BigInt(firstIccid) ||
        "Le dernier ICCID doit être supérieur au premier ICCID"
      );
    },
  };
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const fetchBatches = async () => {
    try {
      let Url = `${process.env.REACT_APP_BACKEND_URL}batch/getAll`;
      if (torole === "franchise" || torole === "PDV") {
        Url = `${process.env.REACT_APP_BACKEND_URL}batch/userRelatedBatches`;
      }
      const response = await axios.get(Url,{withCredentials: true});
      setBatches(response.data.data);
    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      setAlert({ show: false, type: "", message: "" });

      data.receiver = entity?.User || entity?.user;
      data.type = "recouvrement";

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}createTransaction`,
        data,
        {
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        if (response.data.isValid) {
          setAlert({
            show: true,
            type: "success",
            message: "Recouvrement déclaré avec succès",
          });
          setTimeout(() => {
            onSuccessClose();
          }, 2000);
        } else {
          setAlert({
            show: true,
            type: "warning",
            message: "Recouvrement invalide. Veuillez vérifier les données.",
          });
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setAlert({
        show: true,
        type: "error",
        message: error.response?.data?.message || "Erreur lors du recouvrement",
      });
      console.error("Error during recouvrement:", error);
    }
  };
  useEffect(() => {
    fetchBatches();
  }, []);
  const renderAlert = () => {
    if (!alert.show) return null;

    const alertProps = {
      error: { color: "failure", icon: XCircle },
      success: { color: "success", icon: CheckCircle },
      warning: { color: "warning", icon: CheckCircle },
    }[alert.type];

    return (
      <Alert
        color={alertProps.color}
        icon={alertProps.icon}
        onDismiss={() => setAlert({ show: false, type: "", message: "" })}
        className="mb-4"
      >
        {alert.message}
      </Alert>
    );
  };
  return (
    <Dialog className="relative z-50" open={open} onClose={onClose}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 ">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 dark:bg-gray-700">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                  <TruckIcon
                    className="h-6 w-6 text-blue-600"
                    aria-hidden="true"
                  />
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle
                    as="h3"
                    className="text-base font-semibold leading-6 text-gray-900 dark:text-white"
                  >
                    Déclarer un recouvrement
                  </DialogTitle>
                  {renderAlert()}
                  <form
                    id="form-1"
                    className="flex flex-col gap-4"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div>
                    <p className="text-sm text-gray-500 dark:text-gray-300">
  Vous êtes sur le point de déclarer un recouvrement de stock du{" "}
  {torole === "franchise" ? (
    <>compte de la Franchise ({entity?.pos_franchise_id?.name})</>
  ) : (
    <>compte du Commercial ({entity?.FirstName + " " + entity?.LastName})</>
  )}{" "}
  vers le compte de ({adminV?.FirstName + " " + adminV?.LastName}). Veuillez
  entrer les détails ci-dessous.
</p>
                    </div>
                    <div>
                      <Label htmlFor="batchName">Batches</Label>
                      <Select
                        id="batchName"
                        {...register("batch_id", { required: true })}
                        required
                      >
                        <option value="" className="text-slate-400" disabled>
                          Sélectionner un batch
                        </option>
                        {batches.map((batch) => (
                          <option
                            key={batch?._id}
                            value={batch?._id}
                            className="text-gray-900 dark:text-white"
                          >
                            {batch?.batch_name}
                          </option>
                        ))}
                      </Select>
                    </div>
                    <div>
                      <Label htmlFor="first_iccid">Premier ICCID</Label>
                      <TextInput
                        id="first_iccid"
                        type="text"
                        placeholder="89******************"
                        maxLength={20}
                        {...register("first_iccid", iccidValidation)}
                        color={errors.first_iccid ? "failure" : "gray"}
                        required
                      />
                      {errors.first_iccid && (
                        <p className="mt-1 text-sm text-red-600">
                          {errors.first_iccid.message}
                        </p>
                      )}
                    </div>
                    <div>
                      <Label htmlFor="last_iccid">Dernier ICCID</Label>
                      <TextInput
                        id="last_iccid"
                        type="text"
                        placeholder="89******************"
                        maxLength={20}
                        {...register("last_iccid", lastIccidValidation)}
                        color={errors.last_iccid ? "failure" : "gray"}
                        required
                      />
                      {errors.last_iccid && (
                        <p className="mt-1 text-sm text-red-600">
                          {errors.last_iccid.message}
                        </p>
                      )}
                    </div>
                    <div>
                      <Label htmlFor="Quantity">Quantity</Label>
                      <TextInput
                        id="Quantity"
                        type="text"
                        disabled
                        value={(() => {
                          const first = watch("first_iccid");
                          const last = watch("last_iccid");
                          if (!first || !last) return 0;
                          const firstNum = BigInt(first.slice(0, -1));
                          const lastNum = BigInt(last.slice(0, -1));
                          return Number(lastNum - firstNum + BigInt(1));
                        })()}
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <Button
                        type="submit"
                        color={"dark"}
                        size={"sm"}
                        form="form-1"
                        isProcessing={loading}
                      >
                        Déclarer le recouvrement
                      </Button>

                      <Button color={"dark"} size={"sm"} onClick={onClose}>
                        Annuler
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 dark:bg-gray-700"></div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
